/**
 * Shared HTTP upload ceilings.
 * Nginx `client_max_body_size` must stay above TRAINING_VIDEO_MAX_BYTES.
 */
export const UPLOAD_MAX_FILE_BYTES = 500 * 1024 * 1024;
export const TRAINING_VIDEO_MAX_BYTES = 2 * 1024 * 1024 * 1024;
export const UPLOAD_FILE_TIMEOUT_MS = 600_000;
export const TRAINING_VIDEO_TIMEOUT_MS = 1_800_000;
